import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { OrganizationApi } from 'api';

export const findOrganization = createAsyncThunk(
  'organization/findOrganization',
  async (_, { rejectWithValue }) => {
    try {
      const response = await OrganizationApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
}

const initialState: IState = {
  list: [],
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findOrganization.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { reducer: organizationReducer } = organizationSlice;

export default organizationReducer;
